<template>
    <gofix-card title=" " classHeader="p-0 m-0" class="heig-frame-child" fullContent>
        <gofix-table
            class="noFullHeight scrollAbsolute"
            :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            @row-click="openModal"
            @new-item="openModal"
            @delete-items="deleteItems"
            ref="gofixTable">
        </gofix-table>
        <b-modal :no-close-on-backdrop="true" modal-class="createFmCode" id="modal-Create" :title="modal.title" hide-footer :centered="true" v-model="modal.open">
            <b-form class="pb-20">
                <gofix-form-input label="Company Name" v-model="modal.data.name" required></gofix-form-input>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="save" :loading="modal.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>
<script>
    export default {
        name: 'case-settings-email-status',
        data () {
            return {
                tableConfig:{
                    name: 'case-settings-requestor-companies',
                    controls:{
                        tableImport:false,
                        tableExport:false,
                        tableColumnSettings:false,
                    },
                    filter: {
                        name: { type: "text", value: "", function: "ilike", with: [] },
                        contract_id: { type: "number", value: this.$route.params.id, function: "=", with: [] }
                    },
                    page: 1,
                    total: 0,
                    isCMS: 'true',
                    useDatabaseView: false,
                    sortColumn: "id",
                    sortDirection: "asc",
                    itemSelected: [],
                    fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            width: 50,
                            thStyle: "width:50px",
                        },
                        {
                            key: 'name',
                            label: 'Name',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: true,
                            with:null,
                            sorting: true,
                        }
                    ]
                },
                tableItems:[],
                modal: {
                    open: false,
                    loading: false,
                    title:"New Email Status",
                    data:{
                        id: null,
                        name: null,
                        contract_id: this.$route.params.id,
                    },
                }
            }
        },
        created() {},
        methods:{
            //Load data list
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.contract_id.value = this.$route.params.id;
                await this.$store.dispatch("CaseSettingsController/getListCaseEmailStatus", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$bvToast.toast("Can not load the data", {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                        reject();
                    })
            },
            //Open modal Edit || Create data
            openModal(item){
                if(item){
                    this.modal.title = "Edit Email Status";
                    this.modal.data = {
                        id: item.id,
                        name: item.name,
                        contract_id: this.$route.params.id,
                    }
                }else{
                    this.modal.title = "New Email Status";
                    this.modal.data = {
                        id: null,
                        name: null,
                        contract_id: this.$route.params.id,
                    }
                }
                this.modal.open = true;
            },
            //Update & Create data
            save(){
                if(!this.modal.data.name){
                    return this.$alertNotification('Email Status Name is a required field.', "danger");
                }
                this.modal.loading = true;
                
                let method    = 'createItemCaseEmailStatus';
                let msg    = 'adding';
                if(this.modal.data.id) {
                    method = 'updateItemCaseEmailStatus';
                    msg    = 'editing';
                }
                this.$store.dispatch(`CaseSettingsController/${method}`, this.modal.data)
                    .then(result => {
                        this.$alertNotification(this.$notificationV2(msg, 'email_status'));
                        this.modal.loading = false;
                        this.modal.open = false;
                        this.$refs['gofixTable'].reloadTableKeepFilter();
                    })
                    .catch(error => {
                        this.modal.loading = false;
                        if(error.response && error.response.data.error.message.error) {
                            this.$alertNotification(error.response.data.error.message.error, "danger");
                        }
                    })
            },
            //Delete data
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("CaseSettingsController/deleteItemCaseEmailStatus", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'email_status'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
        }
    }
</script>
